import React, { useEffect, useState } from 'react'
import { list, sendEmailNotificationByCId, setEmailNotificationData } from '../api/company';
import Loader from '../components/Loader';
import PopupModal from '../components/PopupModal';



export default function SendEmailSetting() {

    const [loading, setLoading] = useState(false);
    const [companyName, setCompanyName] = useState("0");
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");

    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [onConfirmAction, setOnConfirmAction] = useState(null);

    const [option, setOption] = useState([{
        "id": "0",
        "companyName": "Please select company"
    }]);

    const [formData, setFormData] = useState({
        email: false,
        notification: false,

        cnsImportZeroTax: false,
        cnsImportNoneZeroTax: false,

        custUKImportZeroTax: false,
        custUKImportNoneZeroTax: false,

        destin8ImportZeroTax: false,
        destin8ImportNoneZeroTax: false,

        cnsExport: false,
        custUKExport: false,
        destin8Export: false,
    });

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: checked,
        }));
    };

    const getCompanyList = async () => {
        setLoading(true);
        let data = await list();
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                companyName: `${obj.companyName} (${obj?.clientID || obj?.email || ""})`,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            })).sort((a, b) =>
                a.companyName.localeCompare(b.companyName, undefined, { sensitivity: "base" })
            )
            ]);

        }

    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const getSendEmailNotificationByCId = async (companyName) => {
        if (companyName !== "0") {
            setLoading(true);
            let userData = await sendEmailNotificationByCId(companyName);
            setLoading(false);
            if (userData.status > 199 && userData.status <= 399) {
                let data = userData.data.data;
                if (data?.sendEmailNotification) {
                    const notificationData = data.sendEmailNotification;
                    setFormData({
                        ...formData,
                        email: notificationData?.email && notificationData.email === "Yes" ? true : false,
                        notification: notificationData?.email && notificationData.notification === "Yes" ? true : false,
                        cnsImportZeroTax: notificationData?.badge && notificationData?.badge?.CNS && notificationData?.badge?.CNS?.["IMPORT(CDS)"] && notificationData?.badge?.CNS?.["IMPORT(CDS)"]?.zerotax && notificationData?.badge?.CNS?.["IMPORT(CDS)"]?.zerotax === "Yes" ? true : false,
                        cnsImportNoneZeroTax: notificationData?.badge && notificationData?.badge?.CNS && notificationData?.badge?.CNS?.["IMPORT(CDS)"] && notificationData?.badge?.CNS?.["IMPORT(CDS)"]?.nonzerotax && notificationData?.badge?.CNS?.["IMPORT(CDS)"]?.nonzerotax === "Yes" ? true : false,
                        cnsExport: notificationData?.badge && notificationData?.badge?.CNS && notificationData?.badge?.CNS?.["EXPORT(CDS)"] && notificationData?.badge?.CNS?.["EXPORT(CDS)"]?.email && notificationData?.badge?.CNS?.["EXPORT(CDS)"]?.email === "Yes" ? true : false,

                        custUKImportZeroTax: notificationData?.badge && notificationData?.badge?.Custuk && notificationData?.badge?.Custuk?.["IMPORT(CDS)"] && notificationData?.badge?.Custuk?.["IMPORT(CDS)"]?.zerotax && notificationData?.badge?.Custuk?.["IMPORT(CDS)"]?.zerotax === "Yes" ? true : false,
                        custUKImportNoneZeroTax: notificationData?.badge && notificationData?.badge?.Custuk && notificationData?.badge?.Custuk?.["IMPORT(CDS)"] && notificationData?.badge?.Custuk?.["IMPORT(CDS)"]?.nonzerotax && notificationData?.badge?.Custuk?.["IMPORT(CDS)"]?.nonzerotax === "Yes" ? true : false,
                        custUKExport: notificationData?.badge && notificationData?.badge?.Custuk && notificationData?.badge?.Custuk?.["EXPORT(CDS)"] && notificationData?.badge?.Custuk?.["EXPORT(CDS)"]?.email && notificationData?.badge?.Custuk?.["EXPORT(CDS)"]?.email === "Yes" ? true : false,

                        destin8ImportZeroTax: notificationData?.badge && notificationData?.badge?.Destin8 && notificationData?.badge?.Destin8?.["IMPORT(CDS)"] && notificationData?.badge?.Destin8?.["IMPORT(CDS)"]?.zerotax && notificationData?.badge?.Destin8?.["IMPORT(CDS)"]?.zerotax === "Yes" ? true : false,
                        destin8ImportNoneZeroTax: notificationData?.badge && notificationData?.badge?.Destin8 && notificationData?.badge?.Destin8?.["IMPORT(CDS)"] && notificationData?.badge?.Destin8?.["IMPORT(CDS)"]?.nonzerotax && notificationData?.badge?.Destin8?.["IMPORT(CDS)"]?.nonzerotax === "Yes" ? true : false,
                        destin8Export: notificationData?.badge && notificationData?.badge?.Destin8 && notificationData?.badge?.Destin8?.["EXPORT(CDS)"] && notificationData?.badge?.Destin8?.["EXPORT(CDS)"]?.email && notificationData?.badge?.Destin8?.["EXPORT(CDS)"]?.email === "Yes" ? true : false,

                    })
                } else {
                    setFormData({
                        ...formData
                    })
                }
            } else {

            }
        } else {

        }
    }
    const handleChange = async (e) => {
        const { value, } = e.target;
        setCompanyName(value);
        getSendEmailNotificationByCId(value);

    }

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `${process.env.PUBLIC_URL}/assets/js/misc.js`; // e.g., '/scripts/some-lib.js'
        script.async = true;
        document.body.appendChild(script);
        return () => {
            // document.getElementById('dynamic-js')?.remove();
        };
    }, []);

    const submitData = async () => {

        if (companyName === "") {
            setApiError("Please select company ");
        } else {
            console.log(formData);
            let sendEmailNotification = {
                "email": formData.email ? "Yes" : "No",
                "notification": formData.notification ? "Yes" : "No",
                "badge": {
                    "CNS": {
                        "IMPORT(CDS)": {
                            "zerotax": formData.cnsImportZeroTax ? "Yes" : "No",
                            "nonzerotax": formData.cnsImportNoneZeroTax ? "Yes" : "No",
                        },
                        "EXPORT(CDS)": {
                            "email": formData.cnsExport ? "Yes" : "No",
                        }
                    },
                    "Destin8": {
                        "IMPORT(CDS)": {
                            "zerotax": formData.destin8ImportZeroTax ? "Yes" : "No",
                            "nonzerotax": formData.destin8ImportNoneZeroTax ? "Yes" : "No",
                        },
                        "EXPORT(CDS)": {
                            "email": formData.destin8Export ? "Yes" : "No",
                        }
                    },
                    "Custuk": {
                        "IMPORT(CDS)": {
                            "zerotax": formData.custUKImportZeroTax ? "Yes" : "No",
                            "nonzerotax": formData.custUKImportNoneZeroTax ? "Yes" : "No",
                        },
                        "EXPORT(CDS)": {
                            "email": formData.custUKExport ? "Yes" : "No",
                        }
                    },
                }
            }
            setLoading(true);
            // const result = option.find(c => c._id === companyName);
            let res = await setEmailNotificationData({ cID: companyName, sendEmailNotification })
            setLoading(false);
            if (res.status > 199 && res.status <= 399) {

                setPopUpMessage({
                    title: "Success",
                    text: res.data.message,
                    cancelLabel: "Close"
                });
                setShowPopup(true);
            } else {
                setErrorStatus('danger')
                setApiError(res.data.message)
            }

        }
    }

    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
                onConfirm={onConfirmAction}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="form-group">
                    <label htmlFor="exampleSelectGender">Company</label>
                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleChange}>
                        {option
                            .filter((obj) => obj.id !== "")
                            .map((obj) => (
                                <option key={obj.id} value={obj.id} cStatus={obj.status}>
                                    {obj.companyName}
                                </option>
                            ))}

                    </select>
                </div>

                <div className="row">

                    <div className="page-header">
                        <h3 className="page-title"> Send email setting </h3>


                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="button" onClick={submitData} className="btn btn-primary me-2">Save</button>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">General Setting</h4>
                                {/* <p className="card-description">Checkbox and radio controls (default appearance is in primary color)</p> */}
                                <form>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input
                                                            name="email"
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={formData.email}
                                                            onChange={handleCheckboxChange}
                                                        /> Email </label>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input
                                                            name="notification"
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={formData.notification}
                                                            onChange={handleCheckboxChange}
                                                        /> Notification </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 grid-margin stretch-card">
                                            <div className="card">
                                                {/* <div className="card-body">
                                                    <h4 className="card-title">Checkbox Controls</h4>
                                                    <p className="card-description">Checkbox and radio controls (default appearance is in primary color)</p>
                                                    <form>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="checkbox" className="form-check-input" /> Default </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="checkbox" className="form-check-input" checked /> Checked </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="checkbox" className="form-check-input" disabled /> Disabled </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="checkbox" className="form-check-input" disabled checked /> Disabled checked
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="radio" className="form-check-input" name="optionsRadios" id="optionsRadios1"
                                                                                value="" /> Default </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="radio" className="form-check-input" name="optionsRadios" id="optionsRadios2"
                                                                                value="option2" checked /> Selected </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="radio" className="form-check-input" name="optionsRadios2" id="optionsRadios3"
                                                                                value="option3" disabled /> Disabled </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <label className="form-check-label">
                                                                            <input type="radio" className="form-check-input" name="optionsRadio2" id="optionsRadios4"
                                                                                value="option4" disabled checked /> Selected and disabled </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div> */}
                                                <div className="card-body">
                                                    {/* <p className="card-description">Add class <code>.form-check</code> for checkbox and radio controls
                                                        in theme colors</p> */}
                                                    <form>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <div className="form-check form-check-primary">
                                                                        {/* <label className="form-check-label">
                                                                            CNS Import </label> */}
                                                                        <h4 className="card-title">CNS Import</h4>
                                                                    </div>
                                                                    <div className="form-check form-check-success">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="cnsImportZeroTax"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.cnsImportZeroTax}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Zero tex </label>
                                                                    </div>
                                                                    <div className="form-check form-check-info">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="cnsImportNoneZeroTax"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.cnsImportNoneZeroTax}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Non Zero </label>
                                                                    </div>
                                                                    <div className="form-check form-check-danger">
                                                                        <h4 className="card-title">CNS Export</h4>
                                                                    </div>
                                                                    <div className="form-check form-check-warning">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="cnsExport"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.cnsExport}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Email </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <div className="form-check form-check-primary">
                                                                        <h4 className="card-title">CustUK Import</h4>
                                                                    </div>
                                                                    <div className="form-check form-check-success">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="custUKImportZeroTax"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.custUKImportZeroTax}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Zero tex </label>
                                                                    </div>
                                                                    <div className="form-check form-check-info">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="custUKImportNoneZeroTax"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.custUKImportNoneZeroTax}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Non Zero </label>
                                                                    </div>
                                                                    <div className="form-check form-check-danger">
                                                                        <h4 className="card-title">CustUK Export</h4>
                                                                    </div>
                                                                    <div className="form-check form-check-warning">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="custUKExport"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.custUKExport}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Email </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <div className="form-check form-check-primary">
                                                                        <h4 className="card-title">Destin8 Import</h4>
                                                                    </div>
                                                                    <div className="form-check form-check-success">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="destin8ImportZeroTax"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.destin8ImportZeroTax}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Zero tex </label>
                                                                    </div>
                                                                    <div className="form-check form-check-info">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="destin8ImportNoneZeroTax"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.destin8ImportNoneZeroTax}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Non Zero </label>
                                                                    </div>
                                                                    <div className="form-check form-check-danger">
                                                                        <h4 className="card-title">Destin8 Export</h4>
                                                                    </div>
                                                                    <div className="form-check form-check-warning">
                                                                        <label className="form-check-label">
                                                                            <input
                                                                                name="destin8Export"
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={formData.destin8Export}
                                                                                onChange={handleCheckboxChange}
                                                                            /> Email </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
